export default __webpack_public_path__ + "assets/images/extremaAlgos-bd1aab0e07d14cb893533344294d4165.png";